import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { Template } from "@/content/templates/template.types";

import { getIcon } from "./feature-icon-map";

export type TemplateKeyFeaturesSectionProps = {
    template: Template;
};

const keyFeaturesStyles = css({
    paddingBlockStart: "32px"
});

const headingStyles = css({
    color: "#505F79",
    fontSize: ".75rem",
    fontWeight: 400,
    letterSpacing: "1px",
    marginBlockEnd: "8px"
});

const featureStyles = css({
    alignItems: "center",
    color: "#172B4D",
    display: "flex",
    height: "40px",
    paddingBlockStart: "8px"
});

const featureTextStyles = css({
    marginInlineStart: "14px"
});

// TODO: will get features from template
export const TemplateKeyFeaturesSection = ({
    template
}: TemplateKeyFeaturesSectionProps) => {
    const intl = useIntl();

    // TODO: temp placeholder data for UI purposes
    const features = template.keyFeatures ?? [];

    const headingText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.keyFeatures.heading",
        defaultMessage: "KEY FEATURES"
    });

    return (
        !!features.length && (
            <section css={keyFeaturesStyles}>
                <h5 css={headingStyles}>{headingText}</h5>
                {features.map((feature) => (
                    <div css={featureStyles} key={feature.name}>
                        {getIcon(feature.name)}
                        <span css={featureTextStyles}>{feature.name}</span>
                    </div>
                ))}
            </section>
        )
    );
};
export default TemplateKeyFeaturesSection;
